import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { EJourneyGameBadgeType } from '../../utils/journeysUtils';

// GraphQL mutation
const UPSERT_JOURNEY_GAME_BADGES_MUTATION = gql`
  mutation upsertJourneyGameBadges(
    $userId: String!
    $gameType: String!
    $data: JourneyGameBadgesInput!
  ) {
    upsertJourneyGameBadges(userId: $userId, gameType: $gameType, data: $data) {
      _id
      userId
      gameType
      earnedBadges {
        type
        value
        earnedAt
      }
    }
  }
`;

// Input types for TypeScript
export interface EarnedBadgeInputType {
  type: EJourneyGameBadgeType;
  value?: string;
  earnedAt: string; // ISO string
}

export interface JourneyGameBadgesInputType {
  earnedBadges: EarnedBadgeInputType[];
}

export interface UpsertJourneyGameBadgesMutationType {
  upsertJourneyGameBadges: {
    _id: string;
    userId: string;
    gameType: string;
    earnedBadges: {
      type: EJourneyGameBadgeType;
      value?: string;
      earnedAt: string;
    }[];
  };
}

export interface UpsertJourneyGameBadgesMutationVariables {
  userId: string;
  gameType: string;
  data: JourneyGameBadgesInputType;
}

// Custom hook
export function useUpsertJourneyGameBadgesMutation(
  options?: MutationHookOptions<
    UpsertJourneyGameBadgesMutationType,
    UpsertJourneyGameBadgesMutationVariables
  >,
) {
  return useMutation<UpsertJourneyGameBadgesMutationType, UpsertJourneyGameBadgesMutationVariables>(
    UPSERT_JOURNEY_GAME_BADGES_MUTATION,
    options,
  );
}
